import { Radio } from '@mui/material';
import React from 'react';

const chipClass = [
  'flex h-11 cursor-pointer select-none items-center justify-center rounded-xl',
  'border border-slate-200 bg-white text-[15px] text-slate-700 shadow-sm',
  'transition duration-200 hover:scale-105 hover:border-blue-500 hover:bg-blue-50 hover:text-blue-700',
  'active:scale-95 active:bg-blue-600 active:text-white sm:h-12',
].join(' ');

const NPS = ({
  openHandler,
}) => (
  <div>
    <div className="my-4 grid grid-cols-6 gap-2 sm:grid-cols-11 sm:gap-1.5">
      <div className={chipClass} onClick={() => openHandler(0)}>
        <p>0</p>
        <Radio className="!hidden" style={{ padding: 0 }} disabled />
      </div>
      <div className={chipClass} onClick={() => openHandler(1)}>
        <p>1</p>
        <Radio className="!hidden" style={{ padding: 0 }} disabled />
      </div>
      <div className={chipClass} onClick={() => openHandler(2)}>
        <p>2</p>
        <Radio className="!hidden" style={{ padding: 0 }} disabled />
      </div>
      <div className={chipClass} onClick={() => openHandler(3)}>
        <p>3</p>
        <Radio className="!hidden" style={{ padding: 0 }} disabled />
      </div>
      <div className={chipClass} onClick={() => openHandler(4)}>
        <p>4</p>
        <Radio className="!hidden" style={{ padding: 0 }} disabled />
      </div>
      <div className={chipClass} onClick={() => openHandler(5)}>
        <p>5</p>
        <Radio className="!hidden" style={{ padding: 0 }} disabled />
      </div>
      <div className={chipClass} onClick={() => openHandler(6)}>
        <p>6</p>
        <Radio className="!hidden" style={{ padding: 0 }} disabled />
      </div>
      <div className={chipClass} onClick={() => openHandler(7)}>
        <p>7</p>
        <Radio className="!hidden" style={{ padding: 0 }} disabled />
      </div>
      <div className={chipClass} onClick={() => openHandler(8)}>
        <p>8</p>
        <Radio className="!hidden" style={{ padding: 0 }} disabled />
      </div>
      <div className={chipClass} onClick={() => openHandler(9)}>
        <p>9</p>
        <Radio className="!hidden" style={{ padding: 0 }} disabled />
      </div>
      <div className={chipClass} onClick={() => openHandler(10)}>
        <p>10</p>
        <Radio className="!hidden" style={{ padding: 0 }} disabled />
      </div>
    </div>
    {/* <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: '2rem',
        }}
      >
        <div>
          <TextField
            // label="Outlined"
            variant="outlined"
            size="small"
            value={npsLowerRating}
            onChange={(e) => setNpsLowerRating(e.target.value)}
          />
        </div>

        <div>
          <TextField
            // label="Outlined"
            variant="outlined"
            size="small"
            value={npsHigherRaing}
            onChange={(e) => setNpsHigherRaing(e.target.value)}
          />
        </div>
      </div> */}
  </div>
);

export default NPS;
